import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	RRKMDifference: null as number | null,
	RRDateDifference: null as number | null,
	AioNvPrp: null as boolean | null,
	AioPrp: null as boolean | null,
	AudtatexBlokPrp: null as boolean | null,
	CapaketPrp: null as boolean | null,
	CaskPrp: null as boolean | null,
	CdbSendPrp: null as boolean | null,
	DodavatelId: null as number | null,
	DodavatelIdText: null as string | null,
	DoplnekMkPrp: null as boolean | null,
	DzmExtEnum: null as boolean | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EdlrtvPrp: null as boolean | null,
	GarDphvypocPrp: null as boolean | null,
	GarSzb: null as number | null,
	GarSzbZao: null as number | null,
	GarakspiaskPrp: null as boolean | null,
	GarnvZakznId: null as number | null,
	GdNr: null as string | null,
	HodSzb: null as number | null,
	HodSzbZao: null as number | null,
	CheckDigitPrp: null as boolean | null,
	CheckDigitRok: null as string | null,
	ChiscenarId: null as number | null,
	KomiseBid: null as string | null,
	KomiseRok: null as string | null,
	KoncernPrp: null as boolean | null,
	LogoId: null as number | null,
	LogoSk: null as number | null,
	ObchodnikNr: null as string | null,
	OvexPrp: null as boolean | null,
	PpnrextPrp: null as boolean | null,
	RegexpIdKomiseNr: null as number | null,
	RegexpIdKomiseRok: null as number | null,
	RegexpIdVin: null as number | null,
	Saga2Prp: null as boolean | null,
	SdaCheckPzn: null as string | null,
	SerialnrPrp: null as boolean | null,
	SilverdatBlokPrp: null as boolean | null,
	SmLogoSk: null as number | null,
	SndruhId: null as number | null,
	SouhlasOdTxt: null as string | null,
	SplatnostInl: null as number | null,
	Text: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VyrobekndOzn: null as string | null,
	VyrobekvozOzn: null as string | null,
	ZaznamId: null as number | null,
	ZpracovosdatId: null as number | null,
	ServiceDuePeriod: null as number | null,
	PrimaryEmailAddress: null as string | null,
	SecondaryEmailAddress: null as string | null,
	FrequencyToSendReminder: null as number | null,
	FrequencyToAutoCloseRequest: null as number | null,
	EtdCriteriaColorTwo: 0 as number,
	EtdCriteriaColorOne: 0 as number,
	EtdCriteriaColorThree: 0 as number,
	EtdCriteriaHourFour: null as number | null,
	EtdCriteriaHourTwo: null as number | null,
	EtdCriteriaHourOne: null as number | null,
	EnableExpiryCriteria: null as boolean | null,
	CriteriaDayOne: null as number | null,
	CriteriaMonthOne: null as number | null,
	CriteriaDayTwo: null as number | null,
	CriteriaMonthTwo: null as number | null,
	CriteriaDayThree: null as number | null,
	CriteriaMonthUptoTwo: null as number | null,
	CriteriaMonthThree: null as number | null,
	CriteriadayUptoTwo: null as number | null,
	CriteriaColorOne: 0 as number,
	CriteriaColorTwo: 0 as number,
	CriteriaColorThree: 0 as number,
	ReseverPartZeroto: null as number | null,
	ReseverPartbetweenTwo: null as number | null,
	ReseverPartbetweenTwoto: null as number | null,
	ReseverPartGreaterthan: null as number | null,
	ReseverPartsColorOne: 0 as number,
	ReseverPartsColorTwo: 0 as number,
	ReseverPartsColorThree: 0 as number,
	EtdCriteriaColorGatePassN: null as number | null,
	EtdCriteriaColorGatePassR: null as number | null,

	EnableServiceDueCriteria: null as boolean | null,
	CriteriaServiceDueDayFirst: 0 as number,
	CriteriaServiceDueDaySecond: 0 as number,
	CriteriaServiceDueDayThird: 0 as number,
	CriteriaServiceDueDayFourth: 0 as number,

	CategoryOnePrimaryPracovnikOzn: null as string | null,
	CategoryOneSecondaryPracovnikOzn: null as string | null,
	CategoryTwoPrimaryPracovnikOzn: null as string | null,
	CategoryTwoSecondaryPracovnikOzn: null as string | null,
	CategoryThreePrimaryPracovnikOzn: null as string | null,
	CategoryThreeSecondaryPracovnikOzn: null as string | null,
	CategoryFourPrimaryPracovnikOzn: null as string | null,
	CategoryFourSecondaryPracovnikOzn: null as string | null,
	CategoryWatchlistConfTheft: null as boolean | null,
	CategoryWatchlistConfLitigation: null as boolean | null,
	CategoryWatchlistConfPaymentDue: null as boolean | null,
	CategoryWatchlistConfVWFSDefaulter: null as boolean | null,
	FirstVisitColorCode: 0 as number,
	PrimaryUserRole: null as string | null,
	PrimaryUsers: [] as number[],
	DateCheckPrp: false as boolean | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
		GdNr: [],
		ZpracovosdatId: [],
		RegexpIdVin: [],
		EtdCriteriaColorThree: [],
		EtdCriteriaColorOne: [],
		EtdCriteriaColorTwo: [],
		CriteriaColorOne: [],
		CriteriaColorTwo: [],
		CriteriaColorThree: [],
		ReseverPartsColorOne: [],
		ReseverPartsColorTwo: [],
		ReseverPartsColorThree: [],
		EtdCriteriaColorGatePassReached: [],
		PracovnikOzn: [] as DropdownItem[],
		Pracovnik: [] as DropdownItem[],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.VYROBEK_VOZ_DODAVATEL_SELECT_MAPPER](state, { data }) {
			state.edit.DodavatelId = data.value;
			state.edit.DodavatelIdText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
